// Import Packages
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useSetRecoilState, useRecoilValue } from 'recoil';

// Import Material UI
import { Grid } from '@material-ui/core';

// Import Icons
import createGroupIcon from '../../../assets/icons/configurationIcons/add-group.svg';

// Import Pages
import AutomService from "../../../services/AutomService/AutomService";
import { alertState, rolePermission, licensePermission } from '../../../recoil-store/recoil-state';
import { makeStyles } from '@material-ui/styles';
import AutomList from './automList/AutomsList';
import AutomGroup from './autom/group/AutomGroup';
import { useDrop } from "react-dnd";
import AutomGroupList from './autom/group/AutomGroupList';
import NewDeleteConfirm from '../../../components/DataTable/NewDeleteConfirm';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

let deletedAutoms = [];
let setSelectedAutomRow;
const Autom = ({ reCheck }) => {
    const { t } = useTranslation();
    const [data, setData] = useState({ allAutomsCount: 0, downloadedCount: 0 });
    const [downloadedData, setDownloadedData] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [refreshAutomGroups, setRefreshAutomGroups] = useState(false);
    const [movedAutomId, setMovedAutomId] = useState(undefined);
    const [chooseBot, setChooseBot] = useState(false);
    const [loading, setLoading] = useState(false); // default true
    const [open, setOpen] = useState(false);
    const [openAddGroup, setOpenAddGroup] = useState(false);
    const [groups, setGroups] = useState([]);
    const [group, setGroup] = useState({});
    const [selectedGroup, setSelectedGroup] = useState({});
    const [draggingFlow, setDraggingFlow] = useState("")
    const activeAutoms = useRef([]);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const setAlert = useSetRecoilState(alertState);
    const license = useRecoilValue(licensePermission);
    const [tab, setTab] = useState("allAutoms");
    const [openShowAutoms, setOpenShowAutoms] = useState({});
    const classes = useStyles();

    useEffect(() => {
        async function fetchData() {
            const response = await AutomService.getAutomNameList();
            if (response?.status) {
                if (Array.isArray(response?.data)) {
                    activeAutoms.current = response.data.filter(x => x.status === 1);
                    if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                        setChooseBot(true);
                    }
                }
            }
        }

        fetchData().then(r => r);
    }, [reCheck]);

    useEffect(() => {
        async function fetchGroups() {
            const response = await AutomService.getAutomGroups();
            if (response?.status) {
                if (response.data.length) {
                    setGroups(response.data)
                }
                else {
                    setGroups([])
                }
            }
            setLoading(false);
        }
        if (!openAddGroup) {
            fetchGroups().then(r => r);
        }
    }, [openAddGroup, refreshAutomGroups]);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            // const response = await AutomService.getAllAutoms('', tab);
            const response = await AutomService.getAutomsCountByFilter();
            if (response?.status) {
                setDataLoading(true);
                if (response?.status) {
                    if (response?.count) {
                        setData({ allAutomsCount: response.count, downloadedCount: response.downloaded_autom_count });
                        // activeAutoms.current = response.data.filter(x => x.status === 1);
                        // if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                        //     setChooseBot(true);
                        // }
                    } else {
                        setData({ allAutomsCount: 0, downloadedCount: 0 });
                    }
                }

            }
            const res = await AutomService.getAllAutoms('', 1);
            if (res?.status) {
                setDataLoading(true);
                if (res?.status) {
                    if (Array.isArray(res?.data)) {
                        setDownloadedData(res.data);
                        activeAutoms.current = res.data.filter(x => x.status === 1);
                        if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                            setChooseBot(true);
                        }
                    } else {
                        setDownloadedData([]);
                    }
                }

            }
            setLoading(false);
        }

        fetchData().then(r => r);
    }, [refresh]);


    const tabChange = (newValue, id, color) => {
        setTab(newValue);
        if (id) {
            setGroup({ name: newValue, id, color })
        }
        else {
            setGroup({})
        }
    };

    function handleOpenShowAutomsInGroup(open) {
        setOpenShowAutoms({ open })
    }
    function handleOpenGroupDialog() {
        setOpenAddGroup(true);
    }
    function handleEditGroup(e, group) {
        setSelectedGroup(group)
        setOpenAddGroup(true);
    }
    async function handleDeleteGroup(group, isDeleteReady) {
        if (!isDeleteReady) {
            const res = await AutomService.showFlowsInDeletedGroup(group.id)
            if (!res.status) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.SHOW-AUTOMS-IN-GROUP-FAILED'),
                    severity: 'error'
                }));
            }
            else if (res.data?.length) {
                setOpenShowAutoms({ open: true, data: res.data })
                setSelectedGroup(group)
            }
            else {
                handleDeleteGroup(group, true)
            }
        }
        else if (isDeleteReady) {
            const response = await AutomService.deleteAutomGroup(selectedGroup?.id ? selectedGroup.id : group.id)
            if (!response.status) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.DELETE-GROUP-FAILED'),
                    severity: 'error'
                }));
            }
            setSelectedGroup({})
            setRefreshAutomGroups((pre) => !pre)
            tabChange("allAutoms")
        }
    }
    async function handleOnDrop(item, groupId) {
        if (groupId === item.automGroupId) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.AUTOM-ALREADY-IN-THIS-GROUP'),
                severity: 'info'
            }));
        }
        const res = await AutomService.addFlowInsideAutomGroup(groupId, { ids: draggingFlow ? draggingFlow : item.id })
        if (!res.status) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.ADD-AUTOM-TO-GROUP-FAILED'),
                severity: 'error'
            }));
        }
        setRefreshAutomGroups((pre) => !pre)
        setMovedAutomId(draggingFlow ? draggingFlow : item.id)
        setAlert(alert => ({
            ...alert,
            show: true,
            message: t('MESSAGES.AUTOMS.ADD-AUTOM-TO-GROUP-SUCCESS'),
            severity: 'success'
        }));
    }

    return (
        <Grid container className={classes.root} spacing={2} style={{ height: "100%" }}>
            <Grid item xs={12} sm={3} md={2} style={{ height: "80%" }}>
                <Grid key={0} item style={{ height: "100%" }}>
                    <div className="third-level-menu autom-group-menu">
                        <h5 className="tlm-header">{t('CONTENT.SIDEBAR.AUTOMS').toUpperCase()}</h5>
                        <div className={`third-level-menu-item-row ${tab === "allAutoms" ? "active-menu" : ""} group-item`} onClick={() => tabChange("allAutoms")}>
                            <div
                                id={`all-flows-menu`}
                                className={`third-level-menu-item`}
                            >
                                {t("CONTENT.AUTOMS-LIST.ALL-AUTOMS")}
                            </div>
                            <div
                                className="automs-count-div"
                                style={{ marginRight: "30px", minWidth: "26.64px" }}>
                                {data.allAutomsCount}
                            </div>
                        </div>
                        <div className={`third-level-menu-item-row ${tab === "downloadedAutoms" ? "active-menu" : ""} group-item`} onClick={() => tabChange("downloadedAutoms")}>
                            <div
                                id={`downloaded-menu`}
                                className={`third-level-menu-item`}
                            // onClick={() => navigateUser(item.to, item.order, vaultMenu.order)}
                            >
                                {t("CONTENT.AUTOMS-LIST.DOWNLOADED")}
                            </div>
                            <div
                                className="automs-count-div"
                                style={{ marginRight: "30px", minWidth: "26.64px" }}>
                                {data.downloadedCount}
                            </div>
                        </div>
                        <div className="tlm-header tlm-group-header">
                            <h5 >{t('CONTENT.SIDEBAR.GROUPS').toUpperCase()} </h5>
                            <img className='add-group-button' onClick={handleOpenGroupDialog} src={createGroupIcon} />
                        </div>
                        <div className='autom-groups-container'>
                            {groups.length ? groups.map((group, index) => {
                                return <AutomGroupList key={index} index={index} group={group} tab={tab} tabChange={tabChange} handleOnDrop={handleOnDrop} />
                            }) : ""}
                        </div>
                    </div>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={9} md={10} style={{ height: "100%", maxHeight: "100%" }}>
                <Grid key={1} style={{ height: "100%" }}>
                    <AutomList
                        activeAutomLen={activeAutoms?.current?.length}
                        botLimit={license?.data?.no_of_rpa_bots}
                        setDraggingFlow={setDraggingFlow}
                        draggingFlow={draggingFlow}
                        // groupId={groupId}
                        group={group}
                        groups={groups}
                        refreshAutomGroups={refreshAutomGroups}
                        movedAutomId={movedAutomId}
                        setRefreshAutomGroups={setRefreshAutomGroups}
                        setRefreshAutoms={setRefresh}
                        handleEditGroup={handleEditGroup}
                        handleDeleteGroup={handleDeleteGroup}
                        handleOnDrop={handleOnDrop}
                        tab={tab}
                        isFirstTime={true}
                    />
                </Grid>
            </Grid>
            {openAddGroup && <AutomGroup setOpen={(e) => setOpenAddGroup(e)} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup}
                setRefreshAutomGroups={setRefreshAutomGroups} setGroup={setGroup} />}
            {openShowAutoms.open && <NewDeleteConfirm titleMessage={t("CONTENT.AUTOMS-LIST.DELETE-GROUP-WARNING-TITLE") + " " + `"${selectedGroup.name}"`} setOpenDelete={handleOpenShowAutomsInGroup}
                message={openShowAutoms.data.map((autom, index) => {
                    if (index < 5) {
                        return <>
                            {index === 0 && <span>{t("CONTENT.AUTOMS-LIST.LISTED-AUTOMS-WILL-BE-REMOVED")}  </span>}
                            <span className="red-alert-message">{autom.name + ", "}</span>
                            {index === 4 && <span><span className="red-alert-message">[+{openShowAutoms.data?.length - 5}]</span></span >}
                        </>
                    }
                })}
                deleteFunc={() => handleDeleteGroup(undefined, true)} />}

        </Grid >
    );
};

export default Autom;
